import React from 'react';
import { Link } from 'react-router-dom';
import { Waves, Heart, Eye } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white py-12 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          <div className="flex items-center gap-2">
            <Waves className="h-6 w-6 text-blue-400" />
            <span className="text-lg font-bold">LimfjordsOdderen</span>
          </div>
          
          <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-slate-400">
            <Link to="/" className="hover:text-white transition-colors">Forside</Link>
            <Link to="/eventyr" className="hover:text-white transition-colors">Eventyr</Link>
            <Link to="/spot-otto" className="hover:text-blue-400 font-medium transition-colors flex items-center gap-1.5">
              <Eye className="w-3.5 h-3.5 text-blue-400" /> Spot Otto
            </Link>
            <Link to="/galleri" className="hover:text-white transition-colors">Galleri</Link>
            <Link to="/kontakt" className="hover:text-white transition-colors">Kontakt</Link>
          </div>

          <div className="text-slate-400 text-xs text-center md:text-right">
            <p>© {new Date().getFullYear()} LimfjordsOdderen. Alle rettigheder forbeholdt (og alle fisk er mine).</p>
            <p className="mt-1 flex items-center justify-center md:justify-end gap-1">
              Lavet med <Heart className="h-3.5 w-3.5 text-red-500 fill-current" /> og masser af sild.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
